// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__l2gf0","container":"styles_container__3WX3v","title":"styles_title__1ZPKc","wrapper":"styles_wrapper__2T3UL","answer":"styles_answer__3Bz7z"};